import React from 'react';
import { Col, Divider, Row, Typography } from 'antd';
import {
  BookOutlined, BuildOutlined, CloudOutlined, EnvironmentOutlined,
  GlobalOutlined, HeartOutlined, HomeOutlined, LinkOutlined,
  RiseOutlined, SwapOutlined, TeamOutlined,
} from '@ant-design/icons';
import '../../../Styles/ResearchLabs.css';

const { Paragraph, Title } = Typography;

const spaceEducationDomains = [
  ['Domain 1 – Space Awareness and Outreach', 'This application domain deals with space education and awareness activities targeting the general public for greater impact.'],
  ['Domain 2 – Education & Training', 'This domain focuses on education and specialized training related to space science, technology, and GNSS. Several education programs, including degree programs, will run throughout the year to develop specialized human resources in Space Science & Technology and GNSS.'],
];

const navigationSystemDomains = [
  ['Domain 3 – GNSS Research & Development', 'This domain focuses specifically on GNSS and the design and development of hardware and software solutions. These solutions address real-life problems in society.'],
  ['Domain 4 – GNSS Applications', 'This domain deals with GNSS applications and spin-offs. GNSS technology will be applied to design practical solutions, applications, and research products.'],
];

const focusedSdgs = [
  ['Good Health and Wellbeing', HeartOutlined],
  ['Quality Education', BookOutlined],
  ['Gender Equality', TeamOutlined],
  ['Decent Work and Economic Growth', RiseOutlined],
  ['Reduced Inequality', SwapOutlined],
  ['Industry, Innovation and Infrastructure', BuildOutlined],
  ['Sustainable Cities and Communities', HomeOutlined],
  ['Climate Action', CloudOutlined],
  ['Life Below Water', GlobalOutlined],
  ['Life On Land', EnvironmentOutlined],
  ['Partnerships to achieve the Goal', LinkOutlined],
];

const GSerlDomain = () => (
  <section className="research-domains-section sdssl-research-domains-section">
    <div className="research-domains-inner">
      <Row gutter={[72, 44]} justify="space-between">
        <Col xs={24} lg={15}>
          <Title level={2} className="research-domains-title">Research Domains</Title>
          <Divider className="ncgsa-divider" />

          <Title level={3} className="research-domain-group-title">
            Space Education Research Lab
          </Title>
          {spaceEducationDomains.map(([title, description]) => (
            <article className="research-domain" key={title}>
              <Title level={4} className="research-domain-title">{title}</Title>
              <Paragraph className="research-domain-copy">{description}</Paragraph>
            </article>
          ))}

          <Title level={3} className="research-domain-group-title research-domain-group-title-followup">
            Global Navigation Satellite System
          </Title>
          {navigationSystemDomains.map(([title, description]) => (
            <article className="research-domain" key={title}>
              <Title level={4} className="research-domain-title">{title}</Title>
              <Paragraph className="research-domain-copy">{description}</Paragraph>
            </article>
          ))}
        </Col>

        <Col xs={24} lg={8}>
          <Title level={2} className="research-domains-title">Focused SDGs</Title>
          <Divider className="ncgsa-divider" />
          <ul className="sdg-focus-list">
            {focusedSdgs.map(([label, Icon]) => (
              <li key={label}>
                <span className="sdg-focus-icon" aria-hidden="true"><Icon /></span>
                <span>{label}</span>
              </li>
            ))}
          </ul>
        </Col>
      </Row>
    </div>
  </section>
);

export default GSerlDomain;
